import fNoviceGuide from '@/components/fNoviceGuide';
import { FI18n, FUtil } from '@freelog/tools-lib';

type StepsType = {
  element: HTMLElement | null;
  title: string;
  topOffset?: number;
  leftOffset?: number;
  rightOffset?: number;
  bottomOffset?: number;
}[];

export class FTourMgr {
  public static init(key: string, steps: StepsType) {
    // console.log('init', key, steps);
    // debugger;
    new FTourMgr(key, steps);
  }

  #NOVICE_GUIDE_LOCALSTORAGE_KEY: string = 'NoviceGuide';

  #key: string;
  #steps: StepsType;

  private constructor(key: string, steps: StepsType) {
    this.#key = key;
    this.#steps = steps;

    if (this.#getNoviceGuide_LocalStorage_Content(key) === 'finished') {
      return;
    }

    this.#show();
  }

  async #show() {
    await FUtil.Tool.promiseSleep(300);

    for (let i: number = 0; i < this.#steps.length; i++) {
      const {
        element,
        title,
        leftOffset = 0,
        rightOffset = 0,
        topOffset = 0,
        bottomOffset = 0,
      } = this.#steps[i];
      if (!element) {
        return;
      }
      element.scrollIntoView({
        // behavior: 'smooth',
        block: 'center',
      });
      // await FUtil.Tool.promiseSleep(300);
      const clientRects = element.getClientRects()[0];

      const result = await fNoviceGuide({
        windowInfo: {
          top: clientRects.y - topOffset,
          left: clientRects.x - leftOffset,
          width: clientRects.width + rightOffset + leftOffset,
          height: clientRects.height + bottomOffset + topOffset,
        },
        title: title,
        step: i + 1,
        total: this.#steps.length,
      });

      if (!result) {
        break;
      }
    }

    this.#setNoviceGuide_LocalStorage_Content(this.#key, 'finished');
  }

  #getNoviceGuide_LocalStorage_Content(key: string) {
    const contentString: string =
      self.localStorage.getItem(this.#NOVICE_GUIDE_LOCALSTORAGE_KEY) || '{}';
    const content = JSON.parse(contentString);
    return content[key];
  }

  #setNoviceGuide_LocalStorage_Content(key: string, value: string) {
    const contentString: string =
      self.localStorage.getItem(this.#NOVICE_GUIDE_LOCALSTORAGE_KEY) || '{}';
    const content = JSON.parse(contentString);
    const newContentString: string = JSON.stringify({
      ...content,
      [key]: value,
    });
    self.localStorage.setItem(
      this.#NOVICE_GUIDE_LOCALSTORAGE_KEY,
      newContentString,
    );
  }
}
